import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Lock } from "lucide-react";

/**
 * Renders children only if the framework is unlocked for the current user.
 * If locked (per editor_reissue_and_peruser_lock_spec.md Part 2), shows a
 * "This assessment is currently locked" placeholder.
 */
export default function FrameworkLockGate({ framework, children }) {
  const [state, setState] = useState({ loading: true, locked: false });
  useEffect(() => {
    api.get("/framework-locks/me").then(({ data }) => {
      const row = (data.locks || []).find((l) => l.framework === framework);
      setState({ loading: false, locked: !!row?.is_locked });
    }).catch(() => setState({ loading: false, locked: false }));
  }, [framework]);

  if (state.loading) return <div className="text-sm text-ink-muted uppercase tracking-wider">Checking access…</div>;
  if (!state.locked) return children;

  return (
    <div className="card-flat p-10 text-center max-w-xl mx-auto my-8" data-testid={`framework-locked-${framework.toLowerCase()}`}>
      <Lock className="w-10 h-10 text-warn mx-auto" />
      <div className="font-display font-bold text-xl mt-4">{framework} Assessment is Locked</div>
      <p className="text-sm text-ink-muted mt-2 leading-relaxed">
        Your administrator hasn't enabled this assessment for your account yet. Contact them to request access.
      </p>
    </div>
  );
}
